// extracted by mini-css-extract-plugin
export default {"agents-page":"AgentsPage_agents-page__Hrrd8","agents-page__bar":"AgentsPage_agents-page__bar__bCIBH","agents-page__search":"AgentsPage_agents-page__search__TA-cR"};